/**
 * @fileoverview LoadingSpinner component styles.
 */

import styled, { keyframes } from 'styled-components';
import { colors } from 'bench-style-constants';

const OFFSET = 186;
const DURATION = '1.5s';
const DEFAULT_SIZE = '20px';

const spinnerRotator = keyframes`
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(270deg);
	}
`;

const spinnerDash = keyframes`
	0% {
		stroke-dashoffset: ${OFFSET};
	}

	50% {
		stroke-dashoffset: ${OFFSET / 4};
		transform: rotate(135deg);
	}

	100% {
		stroke-dashoffset: ${OFFSET};
		transform: rotate(450deg);
	}
`;

const StyledLoadingSpinner = styled.div`
  width: ${DEFAULT_SIZE};
  height: ${DEFAULT_SIZE};

  svg {
    width: ${DEFAULT_SIZE};
    height: ${DEFAULT_SIZE};
    animation: ${spinnerRotator} ${DURATION} linear infinite;
    transition: none;

    circle {
      stroke-dasharray: ${OFFSET};
      stroke-dashoffset: 0;
      transform-origin: center;
      stroke: ${colors.water};
      animation: ${spinnerDash} ${DURATION} ease-in-out infinite;
    }
  }
`;

export default StyledLoadingSpinner;
